import { FC, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { Card, CardContent, CardHeader, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CheckIcon from '@material-ui/icons/Check';
import { FormHandles, SubmitHandler } from '@unform/core';
import { Form } from '@unform/web';
import Button from 'src/components/Button';
import TextField from 'src/components/Form/TextField';
import { IUser } from 'src/interfaces/models';
import api from 'src/services/api';
import { AuthActions } from 'src/store/ducks/auth';
import { handleApiResponseErrors, showFormErrors } from 'src/utils/errors';
import yupValidate from 'src/utils/yupValidate';
import profileSchema from 'src/validators/User/profile.schema';

import { Actions, Container } from './styles';

const Profile: FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit: SubmitHandler = async (formData) => {
    try {
      setLoading(true);
      formRef.current?.setErrors({});

      const { success, data, errors } = await yupValidate(
        profileSchema,
        formData,
      );

      if (!success) {
        return showFormErrors(errors, formRef);
      }

      const response = await api.put<IUser>('admin/me', data);

      const user = response.data;

      dispatch(AuthActions.authProfile(user));

      toast('Perfil atualizado com sucesso', { type: 'success' });

      history.push('/dashboard');
    } catch (error) {
      handleApiResponseErrors(error.response, 'Erro', profileSchema, formRef);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Card>
        <CardHeader title="Perfil" />

        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={{
            name: user?.name,
            email: user?.email,
          }}
        >
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <TextField name="name" label="Nome" autoFocus />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField name="email" label="E-mail" />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      Preencha os campos abaixo <strong>somente</strong> se
                      deseja alterar sua senha.
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      name="password"
                      type="password"
                      label="Nova Senha"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      name="password_confirmation"
                      type="password"
                      label="Confirmar Nova Senha"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>

          <Actions>
            <Button
              type="submit"
              loading={loading}
              variant="contained"
              color="primary"
              onClick={() => formRef.current?.submitForm()}
              startIcon={<CheckIcon />}
            >
              Salvar
            </Button>
          </Actions>
        </Form>
      </Card>
    </Container>
  );
};

export default Profile;
